<template>
  <div
    :class="{dark: isDark}"
    class="total-time"
  >{{ duration }}</div>
</template>

<script>
import Time from '../helpers/Time'

export default {
  props: {
    store: {
      type: Object,
      default: function () {}
    }
  },
  computed: {
    duration () {
      return Time.iso(this.store.state.duration)
    },
    isDark () { return this.store.state.isDark }
  }
}
</script>

<style lang="scss" scoped>
@import 'node_modules/simplecast-styles/src/assets/styles/_core/colors.scss';
@import 'node_modules/simplecast-styles/src/assets/styles/_core/fonts.scss';

.total-time {
  background: $white-trans-800;
  border-radius: 2px;
  height: 16px;
  margin: -8px 8px 0 0;
  padding: 0 5px;
  top: 50%;
  position: absolute;
  right: 0;
  z-index: 4;

  @include font-xs();

  font-size: .6428rem;

  &.dark {
    background: $black-trans-800;
    color: $white-trans-700;
  }
}
</style>
